import React, { useState, useEffect } from 'react';
import {
    FaInstagram,
    FaEnvelope,
    FaYoutube,
    FaFacebook,
    FaPhone,
    FaMapMarkerAlt,
    FaUsers,
    FaCalendarDay,
    FaCalendarAlt,
    FaEye
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { visitorService } from '../../services/visitorService';
import { surveyService } from '../../services/surveyService';

const Footer = () => {
    const [stats, setStats] = useState({
        today: 0,
        today_growth: 0,
        month: 0,
        month_growth: 0,
        total: 0,
        total_unique: 0,
    });
    const [loading, setLoading] = useState(true);
    const [satisfaction, setSatisfaction] = useState(94); 

    const [surveyData, setSurveyData] = useState({
        percentage: 0,
        average_score: 0,
        total_responden: 0,
        this_month: 0,
        growth: 0,
        ikm_label: '-',
        ikm_kategori: '-',
        ikm_color: 'gray',
    });

    // Fetch statistik dari API
    useEffect(() => {
        loadStatistics();
        loadSatisfaction();
    }, []);

    const loadSatisfaction = async () => {
        const result = await surveyService.getSatisfaction();
        if (result.success) {
            setSurveyData(result.data);
        }
    };

    const loadStatistics = async () => {
        setLoading(true);
        const result = await visitorService.getStatistics();
        if (result.success) {
            setStats(prev => ({
                ...prev,
                ...result.data,
                satisfaction: 94
            }));
        }
        setLoading(false);
    };

    const formatNumber = (num) => {
        if (!num && num !== 0) return '0';
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1) + 'M';
        }
        if (num >= 1000) {
            return (num / 1000).toFixed(1) + 'K';
        }
        return num.toString();
    };

    return (
        <footer className="text-white">

            {/* ==================== STATISTIK SECTION ==================== */}
            <div className="bg-gradient-to-r from-[#0F172A] to-[#229B91] border-b border-white/10">
                <div className="container mx-auto px-4 py-10">
                    <div className="text-center mb-8">
                        <h3 className="text-2xl font-bold mb-2">Statistik Website</h3>
                        <p className="text-gray-300">Data kunjungan dan layanan BPKAD Kota Magelang</p>
                    </div>

                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">

                        {/* Card 1: Pengunjung Hari Ini */}
                        <div className="relative group">
                            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/10 transition-all duration-300 transform hover:scale-105">
                                <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:animate-pulse">
                                    <FaCalendarDay className="text-2xl text-white" />
                                </div>
                                <div className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-blue-400 to-blue-200 bg-clip-text text-transparent">
                                    {loading ? '...' : formatNumber(stats.today)}
                                </div>
                                <p className="text-gray-300 text-sm">Pengunjung Hari Ini</p>
                                <div className={`mt-2 text-xs ${stats.today_growth >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                                    <span className="inline-block mr-1">
                                        {stats.today_growth >= 0 ? '↑' : '↓'}
                                    </span>
                                    {Math.abs(stats.today_growth)}% dari kemarin
                                </div>
                            </div>
                        </div>

                        {/* Card 2: Pengunjung Bulan Ini */}
                        <div className="relative group">
                            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/10 transition-all duration-300 transform hover:scale-105">
                                <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-green-700 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:animate-pulse">
                                    <FaCalendarAlt className="text-2xl text-white" />
                                </div>
                                <div className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-green-400 to-green-200 bg-clip-text text-transparent">
                                    {loading ? '...' : formatNumber(stats.month)}
                                </div>
                                <p className="text-gray-300 text-sm">Pengunjung Bulan Ini</p>
                                <div className={`mt-2 text-xs ${stats.month_growth >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                                    <span className="inline-block mr-1">
                                        {stats.month_growth >= 0 ? '↑' : '↓'}
                                    </span>
                                    {Math.abs(stats.month_growth)}% dari bulan lalu
                                </div>
                            </div>
                        </div>

                        {/* Card 3: Total Pengunjung */}
                        <div className="relative group">
                            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/10 transition-all duration-300 transform hover:scale-105">
                                <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-purple-700 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:animate-pulse">
                                    <FaUsers className="text-2xl text-white" />
                                </div>
                                <div className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-purple-400 to-purple-200 bg-clip-text text-transparent">
                                    {loading ? '...' : formatNumber(stats.total)}
                                </div>
                                <p className="text-gray-300 text-sm">Total Pengunjung</p>
                                <div className="mt-2 text-xs text-purple-300">
                                    {loading ? '-' : `${formatNumber(stats.total_unique)}`}
                                </div>
                            </div>
                        </div>

                        {/* Card 4: Kepuasan Masyarakat */}
                        <div className="relative group">
                            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/10 transition-all duration-300 transform hover:scale-105">

                                {/* Icon dengan warna berdasarkan kategori IKM */}
                                <div className={`w-14 h-14 bg-gradient-to-br ${surveyData.ikm_color === 'green' ? 'from-green-500 to-green-700' :
                                        surveyData.ikm_color === 'blue' ? 'from-blue-500 to-blue-700' :
                                            surveyData.ikm_color === 'yellow' ? 'from-yellow-500 to-yellow-700' :
                                                surveyData.ikm_color === 'red' ? 'from-red-500 to-red-700' :
                                                    'from-yellow-500 to-yellow-700'
                                    } rounded-full flex items-center justify-center mx-auto mb-4 group-hover:animate-pulse`}>
                                    <FaEye className="text-2xl text-white" />
                                </div>

                                {/* Persentase Kepuasan */}
                                <div className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text text-transparent">
                                    {surveyData.percentage}%
                                </div>

                                {/* Label */}
                                <p className="text-gray-300 text-sm">Kepuasan Masyarakat</p>

                                {/* Info Tambahan: Total Responden & IKM */}
                                <div className="mt-2 flex flex-col items-center gap-1">
                                    {/* Bintang */}
                                    <div className="flex text-yellow-400 text-xs">
                                        {Array.from({ length: 5 }).map((_, i) => (
                                            <span key={i}>
                                                {i < Math.round(surveyData.average_score) ? '★' : '☆'}
                                            </span>
                                        ))}
                                    </div>

                                    {/* Total responden */}
                                    {/*<div className="text-[10px] text-gray-400">
                                        {surveyData.total_responden > 0
                                            ? `${formatNumber(surveyData.total_responden)} responden`
                                            : 'Belum ada responden'
                                        }
                                    </div>*/}

                                    {/* Badge IKM */}
                                    {/*{surveyData.ikm_label && surveyData.ikm_label !== '-' && (
                                        <div className={`text-[9px] font-bold px-2 py-0.5 rounded-full ${surveyData.ikm_color === 'green' ? 'bg-green-500/20 text-green-300' :
                                                surveyData.ikm_color === 'blue' ? 'bg-blue-500/20 text-blue-300' :
                                                    surveyData.ikm_color === 'yellow' ? 'bg-yellow-500/20 text-yellow-300' :
                                                        surveyData.ikm_color === 'red' ? 'bg-red-500/20 text-red-300' :
                                                            'bg-gray-500/20 text-gray-300'
                                            }`}>
                                            IKM {surveyData.ikm_kategori} - {surveyData.ikm_label}
                                        </div>
                                    )}*/}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Progress Bar Kepuasan */}
                    {/*<div className="mt-8 bg-white/5 rounded-xl p-6">
                        <div className="flex items-center justify-between mb-2">
                            <span className="text-sm text-gray-300">Tingkat Kepuasan Layanan</span>
                            <span className="text-sm font-bold text-[#4CAF50]">{stats.satisfaction}%</span>
                        </div>
                        <div className="w-full bg-white/10 rounded-full h-3 overflow-hidden">
                            <div
                                className="bg-gradient-to-r from-[#0D9488] to-green-400 h-full rounded-full transition-all duration-1000 ease-out"
                                style={{ width: `${stats.satisfaction}%` }}
                            >
                                <div className="h-full w-full bg-white/20 animate-pulse"></div>
                            </div>
                        </div>
                        <div className="flex justify-between mt-2 text-xs text-gray-500">
                            <span>0%</span>
                            <span>50%</span>
                            <span>100%</span>
                        </div>
                    </div>*/}
                </div>
            </div>

            {/* ==================== FOOTER CONTENT ==================== */}
            <div className="relative overflow-hidden">
                {/* Layer 1: Warna Solid Hijau Gelap */}
                <div
                    className="absolute inset-0 z-0"
                    style={{
                        background: 'linear-gradient(to bottom, #0F172A 0%, #0F4C3A 50%, #0F172A 100%)'
                    }}
                />

                {/* Layer 2: Texture Pattern */}
                <div
                    className="absolute inset-0 z-0 opacity-30"
                    style={{
                        backgroundImage: `
                            radial-gradient(circle at 20% 30%, rgba(76, 175, 80, 0.15) 0%, transparent 40%),
                            radial-gradient(circle at 80% 70%, rgba(15, 118, 110, 0.2) 0%, transparent 40%),
                            radial-gradient(circle at 50% 50%, rgba(34, 155, 145, 0.1) 0%, transparent 60%)
                        `
                    }}
                />

                {/* Layer 3: Subtle Dot Pattern */}
                <div
                    className="absolute inset-0 z-0 opacity-[0.15]"
                    style={{
                        backgroundImage: 'radial-gradient(rgba(255, 255, 255, 0.5) 1px, transparent 1px)',
                        backgroundSize: '24px 24px'
                    }}
                />

                {/* Layer 4: Diagonal Lines Pattern */}
                <div
                    className="absolute inset-0 z-0 opacity-[0.05]"
                    style={{
                        backgroundImage: 'repeating-linear-gradient(45deg, rgba(255,255,255,0.8) 0px, rgba(255,255,255,0.8) 1px, transparent 1px, transparent 20px)'
                    }}
                />

                {/* Layer 5: Banner PNG */}
                <div
                    className="absolute inset-0 z-0"
                    style={{
                        backgroundImage: 'url(/images/footer-banner-removebg.png)',
                        backgroundSize: 'contain',
                        backgroundPosition: 'center bottom',
                        backgroundRepeat: 'no-repeat'
                    }}
                />

                {/* Layer 6: Vignette */}
                <div
                    className="absolute inset-0 z-0"
                    style={{
                        background: 'radial-gradient(ellipse at center, transparent 40%, rgba(15, 23, 42, 0.4) 100%)'
                    }}
                />

                {/* Content */}
                <div className="relative z-10 container mx-auto px-4 py-12">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

                        {/* Kolom 1 - Logo dan Sosial Media */}
                        <div className="bg-black/30 rounded-xl p-5 border border-white/10 hover:border-[#4CAF50]/30 transition-colors duration-300">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center mb-3 bg-white/20 shadow-lg border-2 border-white/40 hover:scale-105 transition-transform duration-300">
                                <img src="/images/Logo-BPKAD.png" alt="Logo BPKAD" className="w-16 h-16 object-contain" />
                            </div>
                            <p className="text-sm text-white mb-4 font-semibold drop-shadow-md">
                                BPKAD Kota Magelang
                            </p>
                            <div className="flex flex-wrap gap-3 mt-4">
                                <a href="https://instagram.com/bpkadmagelang" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#4CAF50] transition-colors drop-shadow-md">
                                    <FaInstagram size={22} />
                                </a>
                                <a href="https://twitter.com/bpkadmagelang" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#4CAF50] transition-colors drop-shadow-md">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                                    </svg>
                                </a>
                                <a href="https://www.youtube.com/@bpkadmagelang" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#4CAF50] transition-colors drop-shadow-md">
                                    <FaYoutube size={22} />
                                </a>
                                <a href="https://www.facebook.com/bpkadmagelang" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#4CAF50] transition-colors drop-shadow-md">
                                    <FaFacebook size={22} />
                                </a>
                                <a href="mailto:bpkad@magelangkota.go.id" className="text-white hover:text-[#4CAF50] transition-colors drop-shadow-md">
                                    <FaEnvelope size={22} />
                                </a>
                            </div>
                        </div>

                        {/* Kolom 2 - Profil */}
                        <div className="bg-black/30 rounded-xl p-5 border border-white/10 hover:border-[#4CAF50]/30 transition-colors duration-300 drop-shadow-md">
                            <h4 className="text-lg font-bold mb-4 text-white border-b border-white/20 pb-2">
                                Profil BPKAD
                            </h4>
                            <ul className="space-y-2 text-gray-100">
                                <li><Link to="/profil/visi-misi" className="hover:text-[#4CAF50] transition-colors">Visi dan Misi</Link></li>
                                <li><Link to="/profil/tupoksi" className="hover:text-[#4CAF50] transition-colors">Tugas Pokok dan Fungsi</Link></li>
                                <li><Link to="/profil/struktur-organisasi" className="hover:text-[#4CAF50] transition-colors">Struktur Organisasi</Link></li>
                                <li><Link to="/profil/standar-pelayanan" className="hover:text-[#4CAF50] transition-colors">Standar Pelayanan</Link></li>
                            </ul>
                        </div>

                        {/* Kolom 3 - Informasi Lainnya */}
                        <div className="bg-black/30 rounded-xl p-5 border border-white/10 hover:border-[#4CAF50]/30 transition-colors duration-300 drop-shadow-md">
                            <h4 className="text-lg font-bold mb-4 text-white border-b border-white/20 pb-2">
                                Informasi Lainnya
                            </h4>
                            <ul className="space-y-2 text-gray-100">
                                <li><Link to="/apbd" className="hover:text-[#4CAF50] transition-colors">APBD</Link></li>
                                <li><Link to="/informasi" className="hover:text-[#4CAF50] transition-colors">Informasi Publik</Link></li>
                                <li><Link to="/faq" className="hover:text-[#4CAF50] transition-colors">FAQ</Link></li>
                                <li><Link to="/aduan" className="hover:text-[#4CAF50] transition-colors">Pengaduan</Link></li>
                                <li><Link to="/informasi/artikel/kegiatan" className="hover:text-[#4CAF50] transition-colors">Berita</Link></li>
                            </ul>
                        </div>

                        {/* Kolom 4 - Kontak */}
                        <div className="bg-black/30 rounded-xl p-5 border border-white/10 hover:border-[#4CAF50]/30 transition-colors duration-300 drop-shadow-md">
                            <h4 className="text-lg font-bold mb-4 text-white border-b border-white/20 pb-2">
                                Kontak Kami
                            </h4>
                            <ul className="space-y-3 text-gray-100">
                                <li className="flex items-start space-x-2">
                                    <FaMapMarkerAlt className="mt-1 flex-shrink-0 text-[#4CAF50]" />
                                    <span className="text-sm">Jl. Jend. Sarwo Edhie Wibowo No.2, Tenjosari, Magersari, Kec. Magelang Selatan,
                                        Kota Magelang, Jawa Tengah 56172</span>
                                </li>
                                <li className="flex items-center space-x-2">
                                    <FaPhone className="flex-shrink-0 text-[#4CAF50]" />
                                    <span className="text-sm">(0293)-363695</span>
                                </li>
                                <li className="flex items-center space-x-2">
                                    <FaEnvelope className="flex-shrink-0 text-[#4CAF50]" />
                                    <span className="text-sm">bpkad@magelangkota.go.id</span>
                                </li>
                            </ul>
                            <div className="mt-4 rounded-lg overflow-hidden shadow-lg border border-white/30">
                                <iframe
                                    src="https://www.google.com/maps?q=Jl.+Jend.+Sudirman+No.+10+Magelang&output=embed"
                                    width="100%"
                                    height="180"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    title="Peta Lokasi BPKAD Kota Magelang"
                                />
                            </div>
                            <p className="text-xs text-gray-200 mt-2">
                                <a
                                    href="https://www.google.com/maps?q=Jl.+Jend.+Sudirman+No.+10+Magelang"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-[#4CAF50] transition-colors"
                                >
                                    Lihat di Google Maps →
                                </a>
                            </p>
                        </div>
                    </div>

                    {/* Copyright */}
                    <div className="mt-8 pt-6 border-t border-white/30 text-center drop-shadow-md">
                        <p className="text-sm text-white">
                            &copy; 2026 BPKAD Kota Magelang. Hak Cipta Dilindungi.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;